import { createContext, useContext, useEffect } from "react";
import { usePlayer } from "./player";


const CrusadeContext = createContext()
export function Crusade(props) {
    const { ...rest } = props;
    const player = usePlayer()

    return <CrusadeContext.Provider
        value={{
            crusade: player.crusade,
            reload: player.reload,
        }}
        {...rest}
    />
}

export function useCrusade() {
    const { crusade, reload } = useContext(CrusadeContext)

    const matchToJoin = crusade.matches.filter(m => m.status == 'init').filter(m => !m.joined)

    return {
        ...crusade,
        matchToJoin,

        reload,
    }
}